import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { db } from "../firebase";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import VehicleCard from "../components/VehicleCard";

export default function MarqueDetails() {
  const { slug } = useParams(); // ici "slug" = le nom de la marque, ex: "Toyota"
  const [voitures, setVoitures] = useState([]);
  const [debugInfo, setDebugInfo] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 🔍 Rechercher les véhicules dont marque == slug
        const vehiculesQuery = query(
          collection(db, "vehicules_auto"),
          where("marque", "==", slug)
        );
        const snap = await getDocs(vehiculesQuery);
        const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        console.log("🔍 Véhicules trouvés :", list);
        setDebugInfo(JSON.stringify(list, null, 2));
        setVoitures(list);
      } catch (error) {
        console.error("❌ Erreur lors du chargement :", error);
      }
    };

    fetchData();
  }, [slug]);

  return (
    <>
      <MenuNav />
      <MobileMenu />
      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
        <Link to="/marques" className="btn btn-outline-secondary">← Retour aux marques</Link>
      </div>
        <h2 className="mb-4">Véhicules de la marque {slug}</h2>

        {voitures.length === 0 ? (
          <p className="text-center text-muted">Aucun véhicule trouvé pour cette marque.</p>
        ) : (
          <div className="row g-4">
            {voitures.map((v) => (
              <div key={v.id} className="col-6 col-md-4 col-lg-3">
                <VehicleCard vehicule={v} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
